import React, { useState, useEffect } from "react";
import {
  Card,
  Modal,
  Form,
  Button,
  Row,
  Col,
  Tabs,
  Tab,
  Nav,
} from "@themesberg/react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  agregarPacienteAction,
  cerrarModalAgregarAction,
} from "../../actions/pacientesActions";
import { getDatosAdicionalesAction } from "../../actions/datosAdicionalesActions";
import DatosAdicionalesRender from "../../components/DatosAdicionales/DatosAdicionalesRender";

export default (props) => {
  const dispatch = useDispatch();

  const { showModalAgregar } = useSelector((state) => state.pacientes);
  const { datosAdicionales, tabsDatosAdicionales } = useSelector(state => state.datosAdicionales);
  const { datosAdicionalesDetalles } = useSelector(state => state.datosAdicionalesDetalles);

  const [agregar, guardar] = useState({
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    fecha_nacimiento: "",
    genero: "",
    telefono: "",
    correo_electronico: "",
  });

  const submitForm = (e) => {
    e.preventDefault();
    
    const datos_adicionales = {
      detalles: datosAdicionalesDetalles,
      tabla: 'CLIENTES',
      id_tabla: null
    }
    agregar.datos_adicionales = datos_adicionales;
    dispatch(agregarPacienteAction(agregar));
  };

  const handleClose = () => {
    dispatch(cerrarModalAgregarAction());
  };

  const onChangeForm = (e) => {
    guardar({
      ...agregar,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal
      as={Modal.Dialog}
      centered
      show={showModalAgregar}
      onHide={handleClose}
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title className="h6">Agregar cliente</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Form onSubmit={submitForm}>
        <Modal.Body>
          <Tab.Container defaultActiveKey="generales">
            <Row>
              <Nav fill variant="tabs" className="mb-3">
                <Nav.Item>
                  <Nav.Link eventKey="generales">Generales</Nav.Link>
                </Nav.Item>
                {tabsDatosAdicionales.map((dato, index) => (
                    <Nav.Item>
                      <Nav.Link eventKey={dato.tabulador}>{dato.tabulador}</Nav.Link>
                    </Nav.Item>
                ))}
              </Nav>
            </Row>
            <Tab.Content>
              <Tab.Pane eventKey="generales" title="Generales">
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Nombre(s)*</Form.Label>
                      <Form.Control
                        type="text"
                        name="nombre"
                        placeholder="Nombre(s)"
                        value={agregar.nombre}
                        onChange={onChangeForm}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Apellido paterno*</Form.Label>
                      <Form.Control
                        type="text"
                        name="apellido_paterno"
                        placeholder="Apellido paterno"
                        value={agregar.apellido_paterno}
                        onChange={onChangeForm}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Apellido materno</Form.Label>
                      <Form.Control
                        type="text"
                        name="apellido_materno"
                        placeholder="Apellido materno"
                        value={agregar.apellido_materno}
                        onChange={onChangeForm}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group className="mb-3">
                  <Form.Label>Fecha nacimiento</Form.Label>
                  <Form.Control
                    type="date"
                    name="fecha_nacimiento"
                    placeholder="Fecha de nacimiento"
                    value={agregar.fecha_nacimiento}
                    onChange={onChangeForm}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label as="legend" column="sm">
                    Genero
                  </Form.Label>
                  <br />
                  <Form.Check
                    inline
                    type="radio"
                    name="genero"
                    label="Masculino"
                    value="M"
                    onChange={onChangeForm}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    name="genero"
                    label="Femenino"
                    value="F"
                    onChange={onChangeForm}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Correo electronico</Form.Label>
                  <Form.Control
                    type="email"
                    name="correo_electronico"
                    placeholder="Correo electronico"
                    value={agregar.correo_electronico}
                    onChange={onChangeForm}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Teléfono*</Form.Label>
                  <Form.Control
                    type="number"
                    name="telefono"
                    placeholder="Teléfono"
                    value={agregar.telefono}
                    onChange={onChangeForm}
                  />
                </Form.Group>
              </Tab.Pane>
              {tabsDatosAdicionales.map((dato, index) => (
                <Tab.Pane eventKey={dato.tabulador} title={dato.tabulador} key={index}>
                  <DatosAdicionalesRender tabulador={dato.tabulador} id_tabla={null} />
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Tab.Container>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="link"
            className="text-gray ms-auto"
            onClick={handleClose}
          >
            Cerrar
          </Button>
          <Button type="submit" variant="secondary">
            Agregar
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
